import { Stack, useLocalSearchParams } from 'expo-router';
import Head from 'expo-router/head';

import { StoreLocatorServiceModeTab } from '@fhs/store-locator';
import { DeliveryAddressModal } from '@fhs-legacy/frontend/src/components/address-modal';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

import { useForwardToStoreLocator } from '../../utils/use-forward-to-store-locator';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

/**
 * The legacy delivery URL. The v2 locator lives on `/store-locator`, so with it on this page
 * forwards there on the delivery tab.
 */
export default function DeliveryAddressPage() {
  const enableStoreLocatorV2 = useFlag('enable-store-locator-v2');
  const params = useLocalSearchParams();

  useForwardToStoreLocator(
    { ...params, tab: StoreLocatorServiceModeTab.DELIVERY },
    Boolean(enableStoreLocatorV2)
  );

  if (enableStoreLocatorV2) {
    // Nothing to show while forwarding, and the modal header would flash over the locator.
    return <Stack.Screen options={{ headerShown: false, animation: 'none' }} />;
  }

  return (
    <>
      <Head>
        <title>Delivery Address - Firehouse Subs</title>
      </Head>
      <DeliveryAddressModal />
    </>
  );
}
